import { Link } from 'react-router-dom';

// Images
import Redbubble from '../images/redbubble.webp';
import Threadless from '../images/threadless.webp';
import TeePublic from '../images/Teepublic.webp';

function StoreMap() {

    return (
        <div className="store-wrapper">
            <div className="store">
                <Link to="https://www.redbubble.com/people/VulshokBersrker/shop" target="_blank">
                    <div className="image-box"> <img src={Redbubble} /> </div>
                    <div className="font-4 bold">RedBubble</div>
                </Link>
                
            </div>

            <div className="store">
                <Link to="https://vulshokbersrker.threadless.com/" target="_blank">
                    <div className="image-box"> <img src={Threadless} /> </div>
                    <div className="font-4 bold">Threadless</div>
                </Link>
            </div>

            <div className="store">
                <Link to="https://www.teepublic.com/user/vulshokbersrker" target="_blank">
                    <div className="image-box"> <img src={TeePublic} /> </div>
                    <div className="font-4 bold">TeePublic</div>
                </Link>
            </div>
        </div>
    );
}
  
export default StoreMap;
  